import { unitChange } from "../../../helper/mathHelper";

/**
 * 
 * @param {} list {rowName,children: {color,displayText,id,name}}
 * @param {Array} expandSignals [signalName]
 */
function getBathtubWidthTableData({ list, expandSignals, berValue, xUnit }) {
  const tableData = [];
  for (const item of list) {
    const { rowName, children } = item;
    // Check whether the signal is folded. If it is folded, it is not displayed
    if (!expandSignals.includes(rowName)) {
      tableData.push({
        signalName: rowName,
        curveName: '',
        width: 0,
        colSpan: 3
      })
    } else {
      for (let i = 0; i < children.length; i++) {
        // if (!(portSelect[rowName] || []).includes(children[i].id)) continue;
        const { width, drawLine } = calculateWidth(berValue, children[i].x, children[i].y, xUnit, children[i].color, children[i].id);
        const data = {
          signalName: rowName,
          curveName: children[i].displayText,
          width,
          color: children[i].color,
          drawLine,
          id: children[i].id
        }
        if (i === 0) {
          data.rowSpan = children.length;
        } else {
          data.rowSpan = 0;
        }
        tableData.push(data);
      }
    }
  }

  return tableData;
}

/**
 * Calculate the bathtub width of each signal
 * @param {*} berValue
 * @param {Array} x
 * @param {Array} y
 * @param {String} xUnit
 */
function calculateWidth(berValue, x, y, xUnit = "V", color, id) {
  // Convert ber value to log(ber) by Math.log10()， Math.log10(3.16e-11) = -10.500312917381596
  const targetY = Math.log10(berValue);
  const targetX = [];
  for (let i = 0, length = x.length; i < length; i++) {
    const x1 = x[i - 1];
    const y1 = y[i - 1];
    const x2 = x[i];
    const y2 = y[i];

    // Check if y is between [y1, y2]
    if ((y1 <= targetY && y2 >= targetY) || (y1 >= targetY && y2 <= targetY)) {
      // Linear interpolation computes x
      const interpolatedX = x1 + ((targetY - y1) * (x2 - x1)) / (y2 - y1);
      // console.log({ x1, y1, x2, y2, interpolatedX });
      targetX.push(interpolatedX);
    }

    if (targetX.length === 2) break;
  }

  let width = "", drawLine = {};
  if (targetX.length === 1) {
    width = "0" + xUnit;
  } else if (targetX.length === 2) {
    // The difference between two adjacent values in targetX List
    const diff = Math.abs(targetX[0] - targetX[1]);
    const { number, unit } = unitChange({ num: diff, oldUnit: "V", newUnit: xUnit, decimals: 3 });
    width = number + unit;
    drawLine = { x: targetX, y: [targetY, targetY], color, id, type: "bathtubWidth", text: width };
  }

  return { width, drawLine }
}
export {
  getBathtubWidthTableData
}